import React from 'react';

export default ({
  children, prop, sortBy, sortAsc, onSort, className,
}) => {
  const classNames = [className, 'table__heading', 'table__heading--sortable'];
  if (prop === sortBy) classNames.push(`table__heading--${sortAsc ? 'desc' : 'asc'}`);

  return (
    <th className={classNames.join(' ')}>
      <button type="button" onClick={() => onSort(prop)}>
        {children}
      </button>
    </th>
  );
};



// WEBPACK FOOTER //
// ./src/components/Th/Th.js